import { defineComponent, openBlock, createElementBlock, createBlock, unref, withCtx, createVNode, createElementVNode, createCommentVNode, createTextVNode } from "vue";
import { CdrBanner, IconInformationFill, CdrButton } from "@rei/cedar";
const _hoisted_1 = {
  class: "terms-conditions-modal"
};
const _hoisted_2 = ["innerHTML"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "TermsAndConditionsModal",
  props: {
    termsText: {},
    isEBike: {
      type: Boolean
    }
  },
  emits: ["acceptTerms", "declineTerms"],
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [_ctx.isEBike ? (openBlock(), createBlock(unref(CdrBanner), {
        key: 0,
        "data-ui": "ebike-message",
        type: "info"
      }, {
        "icon-left": withCtx(() => [createVNode(unref(IconInformationFill))]),
        default: withCtx(() => [_cache[2] || (_cache[2] = createElementVNode("div", {
          class: "terms-conditions-modal__ebike-message-text"
        }, " Ride your e-bike responsibly. Always check the land manager’s current rules on where your e-bike class can ride. ", -1))]),
        _: 1,
        __: [2]
      })) : createCommentVNode("", true), _cache[5] || (_cache[5] = createElementVNode("div", {
        class: "terms-conditions-modal__warning-head",
        "data-ui": "terms-conditions-head"
      }, " Warning: Please read carefully before accepting. ", -1)), createElementVNode("div", {
        "data-ui": "terms-conditions-body",
        innerHTML: _ctx.termsText
      }, null, 8, _hoisted_2), _cache[6] || (_cache[6] = createElementVNode("p", {
        class: "terms-conditions-modal__warning-foot",
        "data-ui": "terms-conditions-foot"
      }, " Click to accept the Terms and Conditions and place item in your shopping cart. ", -1)), createVNode(unref(CdrButton), {
        class: "terms-conditions-modal__accept",
        "data-ui": "terms-conditions-accept",
        onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("acceptTerms"))
      }, {
        default: withCtx(() => _cache[3] || (_cache[3] = [createTextVNode(" Accept ")])),
        _: 1,
        __: [3]
      }), createVNode(unref(CdrButton), {
        modifier: "secondary",
        "data-ui": "terms-conditions-cancel",
        onClick: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("declineTerms"))
      }, {
        default: withCtx(() => _cache[4] || (_cache[4] = [createTextVNode(" Cancel ")])),
        _: 1,
        __: [4]
      })]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=TermsAndConditionsModal2.mjs.map
